import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsModule, MDBBootstrapModulesPro, MDBModalRef } from 'ng-uikit-pro-standard';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { IBaryModalEvent } from 'models/bary-modal-event';

import { BaryButtonComponent } from '../../../bary-button/bary-button.component';

import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { FaDirectiveEnum } from '../../../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../../../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-modal-error-refund-payzen',
  templateUrl: './bary-modal-error-refund-payzen.component.html',
  standalone: true,
  imports: [BaryButtonComponent, CommonModule, TranslateModule, IconsModule, MDBBootstrapModulesPro, BaryIconComponent],
})
export class BaryModalErrorRefundPayzenComponent {
  readonly #translateService = inject(TranslateService);
  readonly #modalRef = inject(MDBModalRef);

  public title: string = this.#translateService.instant('ERROR.PAYZEN');
  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public errorMessage?: string;
  public errorCode?: string;

  protected readonly FAS = FaDirectiveEnum.FAS;

  public handleClick(): void {
    this.action.next();
    this.#modalRef.hide();
  }
}
